import { Checkbox } from "@/components/ui/checkbox";
import { RowData } from "@tanstack/react-table";
import { RowWithIdentifier } from "../_helpers/row-identifier";
import { ImplementedDisplayColumnDef } from "../types";

export const createSelectionColumn = <
  TData extends RowData & RowWithIdentifier,
  TValue = unknown,
>(): ImplementedDisplayColumnDef<TData, TValue> => ({
  id: "select-col",
  size: 50,
  minSize: 50,
  maxSize: 50,
  enableSorting: false,
  header: ({ table }) => {
    const isMultiSelectionEnabled = table.options.enableMultiRowSelection;

    if (!isMultiSelectionEnabled) {
      return <div className="flex h-4 w-4 items-center justify-center" />;
    }

    return (
      <Checkbox
        className="mx-auto"
        checked={table.getIsAllRowsSelected()}
        onClick={(event) => event.stopPropagation()}
        onAuxClick={(event) => event.stopPropagation()}
        onCheckedChange={(checked) => table.toggleAllRowsSelected(checked === true)}
      />
    );
  },
  cell: ({ row }) => (
    <Checkbox
      className="mx-auto"
      checked={row.getIsSelected()}
      disabled={!row.getCanSelect()}
      onClick={(event) => event.stopPropagation()}
      onAuxClick={(event) => event.stopPropagation()}
      onCheckedChange={(checked) => row.toggleSelected(checked === true)}
    />
  ),
});
